import type { DocumentTemplateSummary } from '../config';

export const isClinicOwnTemplate = (
  template: Pick<
    DocumentTemplateSummary,
    | 'edited_by_clinic'
    | 'added_by_clinic'
    | 'source_kind'
    | 'derived_from_kind'
    | 'partner_source'
  >,
) =>
  !!template.edited_by_clinic ||
  !!template.added_by_clinic ||
  (template.source_kind === 'organization' &&
    !template.derived_from_kind &&
    !template.partner_source);
